import styles from './PromoBlock.module.scss';
import parse from 'html-react-parser';
import { IPromoBlock } from './types';

const PromoBlock = ({ title, subtitle, children }: IPromoBlock) => {
  return (
    <div className={`${styles.promo_block}`}>
      <div className={`${styles.title_container}`}>
        <div className={styles.title_container_inner}>
          <p className={styles.title}>{title}</p>
          <div className={styles.subtitle_container}>{parse(`${subtitle}`)}</div>
        </div>
      </div>
      {children}
    </div>
  );
};
export default PromoBlock;
